import { keepPreviousData } from '@tanstack/react-query';
import {
    AccountingExportIntegrationAccountingExportGetParameters,
    AccountingExportIntegrationAccountingExportUpdateParameters,
    AccountingExportIntegrationExportRequest,
    InvalidateQueries,
    useRepositoryMutation,
    useRepositoryQuery,
} from '@mews-commander/data-access';
import { lt, showSuccessAlert } from '@mews/framework';
import { downloadFile } from '@mews-commander/utils';

const queriesToInvalidate: InvalidateQueries = {
    accountingExportIntegrationConfiguration: ['get'],
};

export const useExportAccountingData = () =>
    useRepositoryMutation('accountingExportIntegrationExport', 'data', {
        transformParams: (params: AccountingExportIntegrationExportRequest) => params,
        onSuccess: (data) => {
            downloadFile(data);
            showSuccessAlert({ description: lt('ExportCompleted') });
        },
    });

export const useExportAccountingConfigurationGet = (params: AccountingExportIntegrationAccountingExportGetParameters) =>
    useRepositoryQuery('accountingExportIntegrationConfiguration', 'get', params, {
        placeholderData: keepPreviousData,
    });

export const useExportAccountingConfigurationUpdate = () =>
    useRepositoryMutation('accountingExportIntegrationConfiguration', 'update', {
        transformParams: (params: AccountingExportIntegrationAccountingExportUpdateParameters) => params,
        invalidateQueries: queriesToInvalidate,
        onSuccess: () => {
            showSuccessAlert({ description: lt('SaveSuccessMessage') });
        },
    });
